import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, FormGroup, Label, H2, Image, } from './Login.styles';
import './Login.css'
import apis from '../../api';
import authenticationService from '../../services/authentication.service';
import { useAuthentication } from "../../session/AuthenticationProvider";
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { FloatLabel } from 'primereact/floatlabel';
import TermsModal from '../TermsModal/TermsModal';
import Base64Downloader from 'common-base64-downloader-react';
import axios from 'axios';
import ReactStoreBadges from 'react-store-badges'
import ReCAPTCHA from "react-google-recaptcha";
import { useHistory } from "react-router-dom";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Login
Description : Pagina de inicio al ingresar al aplicativo remunerlite, pagina de 
              logueo.
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina - Pagina de Login
2/11/2021 Cristian Andres Pizo Mina – Se modifico logeo al paquete authenticationService.
05/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Login() {

    // Declarar variables de estado
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [mostrarSpiner, setMostrarSpiner] = useState(false);
    const [emailRestore, setEmailRestore] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [token, setToken] = useState("");
    const toast = useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenActivation, setIsOpenActivation] = React.useState(false);
    const [isOpenToken, setIsOpenToken] = React.useState(false);
    const [isOpenPassword, setIsOpenPassword] = React.useState(false);
    const [isOpenTerms, setIsOpenTerms] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingPass, setLoadingPass] = useState(false);
    const [loadingRestart, setLoadingRestart] = useState(false);
    const auth = useAuthentication();
    const [captcha, setCaptcha] = useState(false);
    const [attempts, setAttempts] = useState(0)
    const [numberId, setNumberId] = useState("")
    const [loadActivate, setLoadActivate] = useState(false)

    const [fileTerms, setFileTerms] = useState("");
    const [filePolicies, setFilePolicies] = useState("");
    const [nameTerms, setNameTerms] = useState("");
    const [namePolicies, setNamePolicies] = useState("");

    const recaptchaRef = React.createRef();

    let history = useHistory();

    useEffect(() => {
        const template = async () => {
            /*Se encarga de mostar el spinner de la vista si no se ha clickeado el botón*/
            await apis.postLegalTerms({}).then(res => {
                let doc1 = "data:application/pdf;base64," + res.data.PDF_POLICIES.DATA
                let doc2 = "data:application/pdf;base64," + res.data.PDF_TERMS.DATA
                setFileTerms(doc2)
                setFilePolicies(doc1)
                setNameTerms(res.data.PDF_TERMS.NAME)
                setNamePolicies(res.data.PDF_POLICIES.NAME)
            }).catch(err => {
                console.log(err)
            })
        }
        template()
    }, []);

    useEffect(() => {
        if (attempts >= 3) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Sobrepasaste los intentos permitidos. Inténtalo nuevamente en 5 minutos', sticky: true });
            setTimeout(() => {
                setAttempts(0)
            }, 300000)
        }
    }, [attempts])

    const showModalTerms = () => {
        setIsOpenTerms(true);
    }

    const hideModalTerms = () => {
        setIsOpenTerms(false);
    }

    // función que octiene el evento del formulario Loguin
    function handleSubmit(event) {
        event.preventDefault();
    }

    // función que valida el formulario de logueo
    function validar() {
        if (email == "") {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar correo', life: 4000 })
            return false
        } if (password == "") {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Agregar contraseña", life: 4000 });
            return false
        } if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email) && !/^\d+$/.test(email)) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error en formato de correo", life: 4000 });
            return false
        }

        return true
    }

    // función limpiar formulario de recuperación de contraseña
    function limpiar() {
        setEmailRestore(null)
        setNewPassword(null)
        setConfirmPassword(null)
        setToken(null)
    }

    // función para loguearse
    const login = async (e) => {
        if (validar()) {
            setMostrarSpiner(true);
            e.preventDefault();
            authenticationService.signIn(email, password).then(user => {
                console.log("El usuario: ", user)
                auth.login(user);
                setMostrarSpiner(false);
                console.log("Términos: ", localStorage.getItem('contract_id'))
                const options = JSON.parse(localStorage.getItem("options_web"))
                if (localStorage.getItem('terms') === 'N') {
                    showModalTerms()
                }
                else {
                    redirectLogin(options)
                }
            })
                .catch(err => {
                    let msg = err
                    toast.current.show({ severity: 'warn', summary: 'Alerta', detail: msg });
                    setMostrarSpiner(false);
                    setAttempts(attempts + 1)
                    console.log(attempts)
                })
        }
    }

    const acceptTermsAndPolicies = () => {
        const headers = {
            authorization: localStorage.getItem('token')
        }
        console.log(localStorage.getItem('routerApi'))
        try {
            axios.post(localStorage.getItem('routerApi') + '/' + process.env.REACT_APP_TERMS_ENDPOINT, {}, { headers }).then(res => {
                console.log('accepted')
                const options = JSON.parse(localStorage.getItem("options_web"))
                redirectLogin(options)
            })
            // apis.acceptTerms({}, headers).then(res => {
            //     console.log('accepted')
            //     //redirectLogin()
            // })
        }
        catch (err) {
            cancelAction()
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "No se pudo iniciar sesion" });
        }
    }

    const redirectLogin = async (options) => {
        setLoading(true)
        // const headers = {
        //     authorization: localStorage.getItem('token')
        // }

        // apis.getBusiness(headers).then(res => {
        //     window.location.href = "./Home";
        //     localStorage.setItem('logo', res.data.COMPANY[0].LOGO)
        //     setMostrarSpiner(false);
        //     setLoading(false)
        // }).catch(err => {
        //     if (localStorage.getItem("type") === "ADMIN") {
        //         if (localStorage.getItem("enabled") === "S") {
        //             window.location.href = "CompanyInfo";
        //         }
        //         if (localStorage.getItem("enabled") === "N") {
        //             console.log("sssssssss")
        //             window.location.href = "Verification";
        //         }
        //     }
        // //     else {
        //         if (localStorage.getItem("type") === "CLIENT") {
        console.log(localStorage.getItem('options_web'))
        const hasDashboard = options.some(opt => opt.items.some(item => item.route === '/Dashboard' || (item.items && item.items.some(subitem => subitem.route === '/Dashboard'))))
        if (localStorage.getItem("type") === "APPROVER" && hasDashboard) {
            window.location.href = "Dashboard";
        }
        else {
            const hasPerson  = options.some(opt => opt.items.some(item => item.route === '/CreatePerson' || (item.items && item.items.some(subitem => subitem.route === '/CreatePerson'))))
            if(hasPerson){
                window.location.href = "CreatePerson";
            }
            else{
                window.location.href = "Welcome"
            }
        }
        //     }
        // }
        setMostrarSpiner(false);
        setLoading(false);
        // })
    }

    const cancelAction = async () => {
        authenticationService.signOut();
        auth.logout();
        hideModalTerms();
    }

    // función para validar si es un correo valido
    function validarCorreo(correo) {

        if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(correo)) {
            return true;
        }
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "Error en formato de correo", life: 4000 });
        setLoadingPass(false)
        return false;
    }

    // función para recuperar contraseña
    const recuperar = () => {
        setLoadingPass(true)
        if (validarCorreo(emailRestore)) {
            const _email = emailRestore;
            const email = {
                EMAIL: _email
            }
            apis.postSendEmail(email).then(res => {
                setIsOpen(false);
                setIsOpenToken(true);
                toast.current.show({ severity: 'success', summary: 'Se envio el token a su correo', detail: 'Por favor revise su bandeja de correo o span', life: 8000 });
            }).catch(err => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
            }).finally(() => {
                setLoadingPass(false)
            })

        }
    }

    // función para validar token
    const verificateToken = () => {
        if(token.length < 10){
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "El token generó incorrectamente. Solicítelo nuevamente", sticky: true });
            setToken("")
            setIsOpenToken(false);
            setIsOpen(true)
        }
        else{
            setIsOpenToken(false);
            setIsOpenPassword(true);
        }
    }

    // función para validar contraseña
    const restarPassword = () => {
        setLoadingRestart(true)
        if (compararPassword()) {
            const _email = emailRestore;
            const _token = token;
            const _newPassword = newPassword;
            const _confirmPassword = confirmPassword;
            const datos = {
                EMAIL: _email,
                PASSNW: _newPassword,
                PASSNW_CONF: _confirmPassword,
                TOKEN: _token
            }
            apis.postUpdatePassword(datos).then(res => {
                limpiar()
                setIsOpenPassword(false);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Contraseña actualizada existosamente. Inicie sesión por favor." });

                // authenticationService.signIn(emailRestore, confirmPassword).then(user => {
                //     auth.login(user);

                //     const headers = {
                //         authorization: localStorage.getItem('token')
                //     }

                //     apis.getBusiness(headers).then(res => {
                //         window.location.href = "./Home";
                //         setMostrarSpiner(false);
                //     }).catch(err => {
                //         window.location.href = "CompanyInfo";
                //     })


                // })
                //     .catch(err => {
                //         toast.current.show({ severity: 'warn', summary: 'Alerta', detail: "No se pudo iniciar sesion" });
                //         setMostrarSpiner(false);
                //     })

            }).catch(err => {
                toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
            }).finally(() => {
                setLoadingRestart(false)
            })
        }
    }

    const activateUser = async () => {
        setLoadActivate(true)
        const payload = {
            NUMBER_ID: numberId
        }
        try {
            await apis.activateUser(payload).then(res => {
                const msg = res.data.MESSAGE
                hideModalActivation()
                setNumberId("")
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: msg, sticky: true });
                setLoadActivate(false)
            })
        }
        catch (err) {
            const msg = err.response.data.message
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: msg, sticky: true });
            setLoadActivate(false)
        }
    }

    // función para comparar contraseñas
    function compararPassword() {
        if (newPassword != confirmPassword) {
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Las contraseñas no conciden', life: 4000 })
            return false
        }
        return true
    }

    // cerrar modal
    const hideModal = () => {
        setIsOpen(false);
    };

    // abrir modal
    const showModal = () => {
        setIsOpen(true);
    };

    const hideModalActivation = () => {
        setIsOpenActivation(false);
    };

    // abrir modal
    const showModalActivation = () => {
        setIsOpenActivation(true);
    };

    // pie de pagina para modal de recuperar contraseña
    const footer = (
        <div>
            <Button className="p-button-sm p-button-secondary" onClick={hideModal}>Cancelar</Button>
            <Button className="p-button-sm" onClick={recuperar} disabled={emailRestore == null || emailRestore == ''} loading={loadingPass}>Enviar</Button>
        </div>
    );

    // encabezado de modal para recuperar contraseña
    const header = (
        <div>
            <p>Ingresa tu correo</p>
        </div>
    );

    // pie de pagina para modal de recuperar contraseña
    const footerActivation = (
        <div>
            <Button className="p-button-sm p-button-secondary" onClick={hideModalActivation}>Cancelar</Button>
            <Button className="p-button-sm" loading={loadActivate} onClick={activateUser} disabled={numberId == null || numberId == ''}>Enviar</Button>
        </div>
    );

    // encabezado de modal para recuperar contraseña
    const headerActivation = (
        <div>
            <p>Ingresa tu documento</p>
        </div>
    );

    // cerrar modal de token
    const hideModalToken = () => {
        setIsOpenToken(false);
    };


    // pie de pagina para modal de token
    const footerToken = (
        <div>
            <Button className="p-button-sm p-button-secondary" onClick={hideModalToken}>Cancelar</Button>
            <Button className="p-button-sm" onClick={verificateToken} disabled={token == null || token == ''}>Continuar</Button>
        </div>
    );

    // encabezado de modal para token
    const headerToken = (
        <div>
            <p>Ingrese su Token</p>
        </div>
    );

    // cerrar modal de contraseña y limpiar campos
    const hideModalPassword = () => {
        limpiar()
        setIsOpenPassword(false);
    };

    // pie de pagina para modal de contraseña
    const footerPassword = (
        <div>
            <Button className="p-button-sm p-button-secondary" onClick={hideModalPassword}>Cancelar</Button>
            <Button className="p-button-sm" onClick={restarPassword} loading={loadingRestart} disabled={newPassword == null || newPassword == '' || confirmPassword == null || confirmPassword == ''}>Continuar</Button>
        </div>
    );

    // encabezado de modal para contraseña
    const headerPassword = (
        <div>
            <p>Ingrese su nueva contraseña</p>
        </div>
    );

    // constantes para el cuerpo de parametros minimo de contraseña
    const passwordHeader = <h6>Su contraseña es:</h6>;
    const passwordFooter = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Sugerencias</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Al menos una mayúscula</li>
                <li>Al menos un número</li>
                <li>Al menos un caracter especial</li>
                <li>Mínimo 8 caracteres</li>
            </ul>
        </React.Fragment>
    );

    const onChange = async () => {
        const recaptchaValue = recaptchaRef.current.getValue();
        let payload = {
            response: recaptchaValue
        }
        try {
            await apis.postCaptcha(payload).then(res => {
                const resp = res.data.success
                if (resp) {
                    setCaptcha(resp)
                }
                else {
                    setCaptcha(resp)
                    recaptchaRef.current.reset();
                }
            })
        }
        catch (err) {
            setCaptcha(false)
            recaptchaRef.current.reset();
        }
    }

    // Return que entrega la pantalla
    return (
        <Form className='form' onSubmit={handleSubmit}>
            <Toast ref={toast} />
            <TermsModal
                accept={acceptTermsAndPolicies}
                cancel={cancelAction}
                isOpenTerms={isOpenTerms}
                setIsOpenTerms={setIsOpenTerms}
                loading={loading}
                setLoading={setLoading}
            />
            <Dialog header={header} footer={footer} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <span className="p-float-label">
                    <InputText style={{ width: "100%" }} id="inputgroup" type="email" value={emailRestore} onChange={(e) => setEmailRestore(e.target.value)} />
                    <label htmlFor="inputgroup">Correo</label>
                </span>
            </Dialog>
            <Dialog header={headerToken} footer={footerToken} visible={isOpenToken} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalToken}>
                <span className="p-float-label">
                    <InputText style={{ width: "100%" }} id="inputgroup" type="text" value={token} onChange={(e) => setToken(e.target.value)} />
                    <label htmlFor="inputgroup">Token</label>
                </span>
            </Dialog>
            <Dialog header={headerPassword} footer={footerPassword} visible={isOpenPassword} position="top" style={{ width: "24rem" }} draggable={false} resizable={false} modal onHide={hideModalPassword}>
                <span className="p-float-label">

                    <Password id="password" name="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                        toggleMask header={passwordHeader} footer={passwordFooter}
                        mediumRegex={"^(((?=.*[!@#$&()\\-`.+,/\"])(?=.*[A-Z]))|((?=.*[!@#$&()\\-`.+,/\"])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})."}
                        strongRegex={"^(?=.*[!@#$&()\\-`.+,/\"])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"}
                        weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte" promptLabel="Digite su contraseña" />
                    <label htmlFor="inputgroup">Nueva contraseña</label>
                </span>
                <span className="p-float-label mt-5">
                    <Password value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} toggleMask feedback={false} />
                    <label htmlFor="inputgroup">Confirme contraseña</label>
                </span>
            </Dialog>
            <Dialog header={headerActivation} footer={footerActivation} visible={isOpenActivation} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalActivation}>
                <span className="p-float-label">
                    <InputText style={{ width: "100%" }} id="inputgroup" type="text" value={numberId} onChange={(e) => setNumberId(e.target.value)} />
                    <label htmlFor="inputgroup">Nro documento</label>
                </span>
            </Dialog>
            <H2 style={{ marginTop: "-2rem", marginBottom: "6rem" }}>
                <Image
                    src={process.env.REACT_APP_LOGO_LOGIN}
                    alt="MiRemuner"
                    style={{ width: "15rem", height: "15rem" }}
                />
            </H2>
            <FormGroup
                style={{ marginTop: "-4rem" }}
            >
                {/* <LabelField htmlFor="label">Correo</LabelField> */}
                {/* <InputText id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)}/> */}
                {/* <Input 
                id="label1"
                autoFocus 
                type="email" 
                value={email}
                placeholder="Ingrese su correo"
                onChange={(e) => setEmail(e.target.value)}
                /> */}

                <div className="p-inputgroup flex-1">
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-user"></i>
                    </span>
                    <span className="p-float-label">
                        <InputText id="inputgroup" autoFocus value={email} style={{ width: 'auto' }} onChange={(e) => setEmail(e.target.value)} />
                        <label htmlFor="inputgroup">Correo o documento</label>
                    </span>
                </div>
            </FormGroup>
            <FormGroup>
                <div className="p-inputgroup" style={{ width: '18rem' }}>
                    <span className="p-inputgroup-addon">
                        <i className="pi pi-lock"></i>
                    </span>
                    <span className="p-float-label">
                        <Password id="password" value={password} inputStyle={{ width: '15.8rem' }} onChange={(e) => setPassword(e.target.value)} feedback={false} toggleMask />
                        <label for="password">Contraseña</label>
                    </span>
                </div>
            </FormGroup>
            <div className="-mt-4">
                <a onClick={showModal} style={{ cursor: 'pointer', color: '#3498DB' }}>¿No recuerdas tu contraseña?</a>
            </div>
            <div>
                <a onClick={showModalActivation} style={{ cursor: 'pointer', color: '#3498DB', textDecoration: 'underline' }}>Habilitarse</a>
            </div>
            {mostrarSpiner && <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-100)" animationDuration=".5s" />}
            {captcha === false && email && password &&
                <ReCAPTCHA
                    ref={recaptchaRef}
                    className='captcha'
                    sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                    onChange={onChange}
                />}
            {mostrarSpiner === false && captcha === true && <Button block type="submit" onClick={login} disabled={attempts >= 3}>
                Iniciar sesion
            </Button>}
            <p className='mt-2 text-xs text-600 line-height-1'>
                Al hacer clic en Iniciar sesión estas aceptando nuestra
                <Base64Downloader style={{ textDecoration: "underline", textDecorationColor: "blue", color: "blue", background: "transparent", border: "0px" }} base64={filePolicies} downloadName={namePolicies}>
                    Política de privacidad de datos.
                </Base64Downloader>
            </p>
            <p className='mt-2 text-xs text-600 line-height-1'>Descarga la app de autogestión en tu dispositivo móvil</p>
            <div className='badges'>
                <a href={process.env.REACT_APP_IOS} target='_blank' style={{
                    display: "inline-block",
                    height: "40px",
                    width: "135px"
                }}>
                    <img src={process.env.REACT_APP_IOS_BADGE} width='100%' height='100%' />
                </a>
                <a href={process.env.REACT_APP_ANDROID} target='_blank' style={{
                    display: "inline-block",
                    height: "40px",
                    width: "135px"
                }}>
                    <img src={process.env.REACT_APP_ANDROID_BADGE} width='100%' height='100%' />
                </a>
            </div>
            <div>
                <p className='mt-2 text-sm text-600 line-height-1'>
                    Validación documentos firmados por Remuner {" "}
                    <a onClick={() => history.push('ValidateDocument')} style={{ textDecoration: "underline", textDecorationColor: "blue", color: "blue", background: "transparent", border: "0px", cursor: 'pointer' }}>
                        Aquí
                    </a>
                </p>
            </div>
        </Form>
    );
}